import React from 'react'

import Profile from './Profile'
import {Link} from "react-router-dom";
import Header from '../inc/Header';
function Profilepage() {
  return (
    <div>
        <Header />
        <br/>
        <br/>
        <br/>
        
        <div className='mahilaloanmurshidabad'>
            <div className="album py-1">
                <div className="container mt-4">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Profile</li>
                        </ol>
                    </nav>
                </div>
                </div>
            </div>
          
        <Profile/>
        <br/>
    </div>
  )
}

export default Profilepage